import { Vector3 } from "three";

import { Collider } from "../../../world/stadium/collider";
import { Context } from "../../../context";

import { ControllerStrategy } from "../strategy";
import { GroundCollisionControllerStrategy } from "./ground";
import { CameraLandmark, CameraLandmarkLookup } from "../../controller";

export class StadiumCollisionControllerStrategy extends ControllerStrategy {
  private pos = new Vector3();
  private target = new Vector3();

  private targetHeightTolerance = 0.5;
  // TODO: do we need to lazy instantiate this to cover different ground
  //       heights in different stadia?
  private refHeight = 3;
  private down = new Vector3(0, -1, 0);
  private delta = new Vector3();
  private goodTarget?: Vector3;

  private collider?: Collider;

  private contextRef?: Context;

  private fallenBack = false;

  init(context: Context): ControllerStrategy {
    super.init(context);

    this.contextRef = context;
    this.refHeight = CameraLandmarkLookup[CameraLandmark.INIT_TARGET].y;

    return this;
  }

  update(_deltaS: number, _gameTimeDelta: number, _frameNum?: number): void {
    if (!this.contextRef?.state.stadiumCollision) return;

    const controller = this.registered;
    const controls = this.registered?.controls;
    const context = this.registered?.contextRef;

    if (controls) {
      if (!this.collider && context?.world?.stadium?.collider) {
        // lazy add collider and configure collision meshes
        this.collider = context.world.stadium.collider;
        controls.colliderMeshes.push(this.collider.collider);
      }

      controls.getPosition(this.pos);
      controls.getTarget(this.target);
      if (this.collider && controller) {
        controller.targetSphere.mesh.position.copy(this.target);

        this.target.y = this.refHeight;

        const intersection = this.collider.raycast(this.target, this.down);
        if (
          !intersection ||
          Math.abs(intersection.distance - this.refHeight) >
            this.targetHeightTolerance
        ) {
          if (this.goodTarget) {
            this.delta.subVectors(this.goodTarget, this.target);
            this.pos.add(this.delta);
            this.target.copy(this.goodTarget);

            controls.setLookAt(
              this.pos.x,
              this.pos.y,
              this.pos.z,
              this.target.x,
              this.target.y,
              this.target.z,
              false
            );
          }
        } else {
          if (!this.goodTarget) {
            this.goodTarget = new Vector3();
          }

          this.goodTarget.copy(this.target);
        }

        // teleport behind home if out-of-bounds
        // using actual camera position
        if (!this.collider.inBounds(controls.camera.position)) {
          console.warn("camera rescue mode", this.pos, this.target);
          controls.setLookAt(0, 10, 30, 0, 5, -40, false);
        }
      } else {
        if (!this.fallenBack) {
          console.warn("falling back to ground collision");
          this.registered?.addAuxStrategy(GroundCollisionControllerStrategy);

          this.fallenBack = true;
        }
      }
    }
  }

  teardown(): void {
    super.teardown();

    if (this.fallenBack) {
      this.registered?.removeAuxStrategy(GroundCollisionControllerStrategy);
    }

    const controller = this.registered;
    if (controller) {
      if (controller.controls) {
        controller.controls.colliderMeshes = [];
      }
    }
  }
}
